import { render } from "./social-selling.vue?vue&type=template&id=ddeb0e2e"
import script from "./social-selling.vue?vue&type=script&lang=js"
export * from "./social-selling.vue?vue&type=script&lang=js"

import "./social-selling.vue?vue&type=style&index=0&id=ddeb0e2e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__